export default __webpack_public_path__ + "static/media/sliced-bread.204b4018.jpg";